function encodeBase64(bytes) {
    let binary = "";
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return btoa(binary);
}

export function createTenantViewRequestId(cryptoImpl = globalThis.crypto) {
    if (!cryptoImpl || typeof cryptoImpl.getRandomValues !== "function") {
        throw new Error("secure randomness is unavailable");
    }
    const bytes = cryptoImpl.getRandomValues(new Uint8Array(16));
    // Stamp the RFC 4122 version (4) and variant bits so the id is a canonical
    // UUIDv4: the portable kernel/canvas artifact validators reject anything
    // else, and the id becomes the stored tenant-view id verbatim.
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    return encodeBase64(bytes);
}
